import { AbstractControl } from "@angular/forms";

/**
 * Return the first error of a control.
 *
 * Any falsy errors are ignored.
 *
 * @example
 * const control = new FormControl('', [ Validators.required ]);
 * const error = getFirstError(control); // 'required'
 *
 * @param control The control to examine
 *
 * @returns The first error.
 */
export function getFirstError(control: AbstractControl): string | null {
  const errors = control.errors;
  if (errors) {
    return Object.keys(errors).find(errorName => control.getError(errorName)) ?? null;
  } else {
    return null;
  }
}
